import isRequired from './isRequired';

function customEventConstructor(
  eventName = isRequired('eventName', 'customEventConstructor'),
) {
  let event;
  if (typeof Event === 'function') {
    event = new Event(eventName);
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }
  return event;
}

export default customEventConstructor;
